module.exports = __webpack_public_path__ + "images/grupo_IDBank.67371808.png";